import SelectPlan from "../../../components/selectPlan";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";

const PlanDetails = forwardRef(({ formData, setFormData }, ref) => {
    const [plan, setPlan] = useState(formData.plan || null);
    const [formErrors, setFormErrors] = useState({});

    useEffect(() => {
        setFormData(prevFormData => ({ ...prevFormData, plan }));
    }, [plan, setFormData]);

    function validate(){
        const errors = {};
        if (!plan) errors.plan = "Selecciona un plan";
        setFormErrors(errors);

        return Object.keys(errors).length === 0;
    }

    useImperativeHandle(ref, () => ({
        validate,
    }));
    
    return (
        <div className="mt-4">
            <div className="m-auto w-100">
                <div className="input-group col-10 col-md-5 p-0 mx-auto justify-content-between">
                    <SelectPlan
                        className="w-75"
                        value={plan}
                        onChange={setPlan}
                        include_hidden={true}
                    />
                    {formErrors.plan && <div style={{ color: 'red' }}>{formErrors.plan}</div>}
                </div>
            </div>
        </div>
      )
});

export default PlanDetails;